import request from '@/utils/request'
// 获取短信验证码
export function sendSmsCode(phonenumber) {
  return request({
    url: `system/api/user/v2/anon/sendSmsCode/${phonenumber}`,
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}
// 绑定手机号
export function bindPhone(data) {
  return request({
    url: `system/wechatUser/bindPhone`,
    method: 'post',
    data: data
  })
}
export function getShareData(params) {
  return request({
    url: 'wechat/wechatH5CourseOrder/anon/getShareData',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js